import React from "react";
import Avatar from "../../avatar";
import RatingItemChange from "./change";

const RatingItemMedium = ({
	photoUrl,
	name,
	federationCode,
	currentRating,
	previousRating,
	ratingChange,
}: {
	photoUrl: string;
	name: string;
	federationCode: string;
	currentRating: string;
	previousRating: string;
	ratingChange: string;
}) => {
	return (
		<div className="item rating medium">
			<div className="itemImage">
				<Avatar photoUrl={photoUrl} size="thumb6" />
			</div>
			<div className="itemBody">
				<div className="name">{name}</div>
			</div>
			<div className="itemExtra">
				<RatingItemChange
					federationCode={federationCode}
					currentRating={currentRating}
					previousRating={previousRating}
					ratingChange={ratingChange}
				/>
			</div>
		</div>
	);
};

export default RatingItemMedium;
